<div class="ai-chart" *transloco="let t; prefix: 'ai-assistant'">
  @if (chartData().config.title) {
    <div class="ai-chart__title">{{ chartData().config.title }}</div>
  }
  @if (chartData().config.description) {
    <div class="ai-chart__description">{{ chartData().config.description }}</div>
  }
  <div class="ai-chart__container" #chartContainer>
    @if (chartData().data.length === 0) {
      <div class="ai-chart__description">{{ t('chart-no-data') }}</div>
    } @else {
      <svg [attr.width]="width()" [attr.height]="height()" class="ai-chart__svg">
        @switch (chartType()) {
          @case ('bar') {
            <g [attr.transform]="'translate(' + margin.left + ',' + margin.top + ')'">
              @for (bar of barData(); track $index) {
                <rect
                  [attr.x]="bar.x"
                  [attr.y]="bar.y"
                  [attr.width]="bar.width"
                  [attr.height]="bar.height"
                  [attr.fill]="bar.color"
                  rx="4"
                />
                @if (bar.label) {
                  <text
                    [attr.x]="bar.labelX"
                    [attr.y]="innerHeight() + 18"
                    text-anchor="middle"
                    class="ai-chart__label"
                    [attr.transform]="'rotate(-35 ' + bar.labelX + ' ' + (innerHeight() + 18) + ')'"
                  >
                    {{ bar.label | slice: 0 : 10 }}
                  </text>
                }
              }
              <!-- Y-axis -->
              <line x1="0" [attr.y1]="0" x2="0" [attr.y2]="innerHeight()" stroke="#e5e7eb" />
              <!-- X-axis -->
              <line
                x1="0"
                [attr.y1]="innerHeight()"
                [attr.x2]="innerWidth()"
                [attr.y2]="innerHeight()"
                stroke="#e5e7eb"
              />
            </g>
          }
          @case ('line') {
            <g [attr.transform]="'translate(' + margin.left + ',' + margin.top + ')'">
              @for (line of lineData(); track line.key) {
                <path
                  [attr.d]="line.path"
                  [attr.stroke]="line.color"
                  stroke-width="2"
                  fill="none"
                />
                @for (point of line.points; track point.x) {
                  <circle [attr.cx]="point.x" [attr.cy]="point.y" r="4" [attr.fill]="line.color" />
                }
              }
              <!-- Axes -->
              <line x1="0" [attr.y1]="0" x2="0" [attr.y2]="innerHeight()" stroke="#e5e7eb" />
              <line
                x1="0"
                [attr.y1]="innerHeight()"
                [attr.x2]="innerWidth()"
                [attr.y2]="innerHeight()"
                stroke="#e5e7eb"
              />
              <!-- X-axis labels -->
              @for (label of xLabels(); track $index) {
                <text
                  [attr.x]="label.x"
                  [attr.y]="innerHeight() + 18"
                  text-anchor="middle"
                  class="ai-chart__label"
                >
                  {{ label.text | slice: 0 : 8 }}
                </text>
              }
            </g>
          }
          @case ('pie') {
            <g [attr.transform]="'translate(' + width() / 2 + ',' + height() / 2 + ')'">
              @for (slice of pieData(); track $index) {
                <path
                  [attr.d]="slice.path"
                  [attr.fill]="slice.color"
                  stroke="white"
                  stroke-width="2"
                />
              }
            </g>
          }
          @default {
            <text x="50%" y="50%" text-anchor="middle" class="ai-chart__label">
              {{ chartType() }} chart
            </text>
          }
        }
      </svg>
    }
  </div>
  @if (chartData().config.takeaway) {
    <div class="ai-chart__takeaway">
      <strong>{{ t('chart-key-insight') }}:</strong> {{ chartData().config.takeaway }}
    </div>
  }
  @if (showLegend()) {
    <div class="ai-chart__legend">
      @for (item of legendItems(); track item.label) {
        <div class="ai-chart__legend-item">
          <span class="ai-chart__legend-color" [style.background-color]="item.color"></span>
          <span class="ai-chart__legend-label">{{ item.label }}</span>
        </div>
      }
    </div>
  }
</div>
